// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { GetAiAgentConfigsCozeCallbackQuery, BaseResponseVoid } from '../../../types';

/**
 * coze oauth回调
 *
 * @export
 * @tags Coze智能体
 * @link [GET] /aiAgentConfigs/coze/callback
 */
export function getAiAgentConfigsCozeCallback(
    options: ApiOptions<never, GetAiAgentConfigsCozeCallbackQuery> & {
        params: GetAiAgentConfigsCozeCallbackQuery;
    }
): Promise<BaseResponseVoid> {
    return request<never, never, GetAiAgentConfigsCozeCallbackQuery>(
        '/aiAgentConfigs/coze/callback',
        { ...options, method: 'get', __$requestCalleeName: 'getAiAgentConfigsCozeCallback' }
    );
}

export const meta = [
    { tags: ['Coze智能体'], path: '/aiAgentConfigs/coze/callback', method: 'get' },
];
